/* eslint-disable no-debugger */
import { map, filter } from 'lodash';
import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from 'axios';

const initialState = {
  isLoading: false,
  isLoadingFile: false,
  excelUpload: null,
  countVal: {},
  segmentationFile: {},
  campaignFile: [],
  appliedRuleFile: null,
  isError: false,
  errorMsg: '',
  isSuccess: false,
  successMsg: '',
  exclusionColumnOption: [],
  checkColumnMapMsg: '',
  checkColumnMapStatus: true
};

const slice = createSlice({
  name: 'collection',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    startIsLoadingFile(state) {
      state.isLoadingFile = true;
    },
    resetCollectionError(state) {
      state.errorMsg = '';
      state.isError = false;
    },
    resetAppliedRuleFile(state) {
      state.appliedRuleFile = null;
    },
    resetSuccess(state) {
      state.successMsg = '';
      state.isSuccess = false;
    },
    resetColumnOption(state) {
      state.exclusionColumnOption = [];
    },
    ColumnOptionSuccess(state, action) {
      state.exclusionColumnOption = action.payload;
    },
    // HAS ERROR
    hasError(state, action) {
      const { message } = action.payload?.data;
      state.isLoading = false;
      state.isLoadingFile = false;
      state.isError = true;
      state.errorMsg = message;
    },
    resetUploadedFile(state, action) {
      state.isLoading = false;
      state.isLoadingFile = false;
      state.excelUpload = null;
    },
    excleFileUploadSuccess(state, action) {
      state.isLoading = false;
      state.isLoadingFile = false;
      state.excelUpload = action.payload;
    },
    collectionApplyRuleSuccess(state, action) {
      state.isLoading = false;
      state.appliedRuleFile = action.payload;
      state.isSuccess = true;
      state.successMsg = 'Rule Applied Successfully';
    },
    // Create Segmentation File
    findSegmentationDataSuccess(state, action) {
      state.segmentationFile = { ...state.segmentationFile, [action.payload.segmentname]: action.payload };
      state.isLoading = false;
    },
    saveCampaignFileSuccess(state, action) {
      state.campaignFile = [...state.campaignFile, action.payload];
    },
    // Create Count Value
    getSegmentationCountSuccess(state, action) {
      state.countVal = { ...state.countVal, [action.payload.segmentname]: action.payload };
      state.isLoading = false;
    },
    // Create Count Value
    resetSegmentationCount(state, action) {
      state.countVal = {};
      state.segmentationFile = {};
      state.isLoading = false;
    },
    // Check ColumnMap For client and project
    getCheckColumnMapSuccess(state, action) {
      state.isLoading = false;
      const { mapped, message } = action.payload;
      if (!mapped) {
        state.checkColumnMapStatus = mapped;
        state.checkColumnMapMsg = message;
      } else {
        state.checkColumnMapStatus = true;
        state.checkColumnMapMsg = '';
      }
    },
    resetCheckColumnMapStatus(state, action) {
      state.isLoading = false;
      state.checkColumnMapStatus = true;
      state.checkColumnMapMsg = '';
    }
  }
});

// Reducer
export default slice.reducer;

// Actions
export const {
  resetCollectionError,
  resetAppliedRuleFile,
  resetUploadedFile,
  resetSegmentationCount,
  resetSuccess,
  resetColumnOption,
  resetCheckColumnMapStatus
} = slice.actions;

// ----------------------------------------------------------------------

export function uploadExcelFile(file) {
  return async (dispatch) => {
    dispatch(slice.actions.startIsLoadingFile());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'post',
        url: `http://smartcollect-api.cp360apps.com/collection-data/create-excel-file`,
        data: file
      });
      dispatch(slice.actions.excleFileUploadSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

export function getColumnOptionSuccess(option) {
  return async (dispatch) => {
    dispatch(slice.actions.resetColumnOption());
    try {
      dispatch(slice.actions.ColumnOptionSuccess(option));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

export function collectionApplyRule(applyData) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'post',
        url: `http://smartcollect-api.cp360apps.com/collection-data/collection-data/`,
        data: applyData
      });
      dispatch(slice.actions.collectionApplyRuleSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// Create Segmentation Data

// converting segment file link into campaign file

export function getCampaignFile(fileObj) {
  return async (dispatch) => {
    let masterFile;
    if (fileObj?.file) {
      axios({
        url: fileObj?.file,
        method: 'GET',
        responseType: 'blob'
      }).then((blob) => {
        masterFile = new File([blob.data], fileObj?.file?.substring(fileObj?.file?.lastIndexOf('/') + 1), {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        dispatch(slice.actions.saveCampaignFileSuccess({ file: masterFile, name: fileObj?.segmentname }));
      });
    }
  };
}

export function findSegmentationData(FileData) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'post',
        url: `http://smartcollect-api.cp360apps.com/segmentation/`,
        data: FileData
      });
      dispatch(getCampaignFile(response.data));
      dispatch(getSegmentationCountData(FileData));
      dispatch(slice.actions.findSegmentationDataSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

export function getSegmentationCountData(FileData) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'post',
        url: `http://smartcollect-api.cp360apps.com/segmentation/segmentation-count/`,
        data: FileData
      });
      dispatch(slice.actions.getSegmentationCountSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

export function checkColumnMapData(data) {
  return async (dispatch) => {
    dispatch(slice.actions.resetCheckColumnMapStatus());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'post',
        url: 'http://smartcollect-api.cp360apps.com/collection-data/check-columnmap/',
        data
      });
      dispatch(slice.actions.getCheckColumnMapSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}
